import PropTypes from 'prop-types'
import React from "react"
import { Col, Row, Modal, ModalHeader, ModalBody, Input, Form, FormFeedback, Label } from "reactstrap";

import * as Yup from "yup";
import { useFormik } from "formik";

import { NumericFormat } from 'react-number-format';

import moment from 'moment';

const ApoliceModal = ({ show, onAddApolice, onCloseClick, processo, newIndex }) => {

    // validation form
    const validApolice = useFormik({
        enableReinitialize: true,

        initialValues: {           
            Tipo: '',
            ProcessoContrato: (processo && processo.NumeroCNJ) || '',
            Seguradora: '',
            Corretora: '',
            ImportanciaSegurada: '',
            Premio: '',
            Endosso: '', 
            Taxa: '',
            InicioVigencia: '',
            FimVigencia: '',           

        },
        validationSchema: Yup.object({                        
            InicioVigencia: Yup.string().required("Por favor informe a Data Início da Vigência da apólice"),
            FimVigencia: Yup.string().required("Por favor informe a Data Fim da Vigência da apólice"),
        }),
        onSubmit: (values) => {

            const newApolice = {            
                Id: newIndex,
                Id_Processo: processo.Id,
                ProcessoContrato: validApolice.values.ProcessoContrato,
                Tipo: validApolice.values.Tipo,
                Seguradora: validApolice.values.Seguradora,
                Corretora: validApolice.values.Corretora,
                ImportanciaSegurada: validApolice.values.ImportanciaSegurada.replace('R$','').replaceAll('.','').replace(',','.') || null,
                Premio: validApolice.values.Premio.replace('R$','').replaceAll('.','').replace(',','.') || null,
                Endosso: validApolice.values.Endosso,
                Taxa: validApolice.values.Taxa.replaceAll('.','').replace(',','.') || null,
                InicioVigencia: validApolice.values.InicioVigencia && moment(validApolice.values.InicioVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD')  || null,
                InicioVigenciaString: validApolice.values.InicioVigencia || null,
                FimVigencia: validApolice.values.FimVigencia && moment(validApolice.values.FimVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD') || null,
                FimVigenciaString: validApolice.values.FimVigencia || null,
            };

            
            onAddApolice(newApolice);
            validApolice.resetForm();
            onCloseClick();
        },
    });

    return (
        <Modal isOpen={show} toggle={onCloseClick} centered={true} backdrop={'static'}>
            <Form onSubmit={(e) => { e.preventDefault(); validApolice.handleSubmit(); return false; }}>
                <div className="modal-content">
                    <ModalHeader toggle={onCloseClick} tag="h4">
                        {/* {!!isEditApolice ? "Editar Apólice" : "Adicionar Apólice"} */}
                        Adicionar Apólice
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col className="col-12">
                                <Row>
                                    <Col lg={12}>
                                        <div className="mb-3">
                                            <Label className="form-label">Tipo</Label>
                                            <Input
                                                name="Tipo"                                                        
                                                type="select"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validApolice.handleChange}                                                                       
                                                onBlur={validApolice.handleBlur}
                                                value={validApolice.values.Tipo || ""}
                                                invalid={
                                                    validApolice.touched.Tipo && validApolice.errors.Tipo ? true : false
                                                }
                                            >                                                    
                                                <option value="">Selecionar...</option>                                                        
                                                <option>Judicial</option>
                                                <option>Recursal</option> 
                                            </Input>                                                    
                                            {validApolice.touched.Tipo && validApolice.errors.Tipo ? (
                                                <FormFeedback type="invalid">{validApolice.errors.Tipo}</FormFeedback>
                                            ) : null}
                                        </div>
                                    </Col> 
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div className="mb-3">
                                            <Label className="form-label">Processo da Apólice</Label>
                                            <Input
                                                name="ProcessoContrato"
                                                placeholder="Processo relacionado a Apólice contratada"
                                                type="text"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validApolice.handleChange}                                                                       
                                                onBlur={validApolice.handleBlur}
                                                value={validApolice.values.ProcessoContrato || ""}
                                                invalid={
                                                    validApolice.touched.ProcessoContrato && validApolice.errors.ProcessoContrato ? true : false
                                                }
                                            />                                                                                                
                                            {validApolice.touched.ProcessoContrato && validApolice.errors.ProcessoContrato ? (
                                                <FormFeedback type="invalid">{validApolice.errors.ProcessoContrato}</FormFeedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div className="mb-3">
                                            <Label className="form-label">Seguradora</Label>
                                            <Input
                                                name="Seguradora"
                                                placeholder="Nome da Seguradora"
                                                type="text"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validApolice.handleChange}                                                                       
                                                onBlur={validApolice.handleBlur}
                                                value={validApolice.values.Seguradora || ""}
                                                invalid={
                                                    validApolice.touched.Seguradora && validApolice.errors.Seguradora ? true : false
                                                }
                                            />
                                            {validApolice.touched.Seguradora && validApolice.errors.Seguradora ? (
                                                <FormFeedback type="invalid">{validApolice.errors.Seguradora}</FormFeedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                    <Col lg={12}>
                                        <div className="mb-3">
                                            <Label className="form-label">Corretora</Label>
                                            <Input
                                                name="Corretora"
                                                placeholder="Nome da Corretora"
                                                type="text"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validApolice.handleChange}
                                                onBlur={validApolice.handleBlur}
                                                value={validApolice.values.Corretora || ""}                                                
                                            />                                            
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Label className="form-label">IS</Label>
                                            <NumericFormat prefix="R$" thousandSeparator="." decimalSeparator="," decimalScale={2} fixedDecimalScale={true} 
                                                className="form-control"
                                                name="ImportanciaSegurada"
                                                placeholder="Valor da Importância Segurada"                                                        
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validApolice.handleChange}
                                                onBlur={validApolice.handleBlur}
                                                value={validApolice.values.ImportanciaSegurada || ""}                                                
                                            />
                                            {validApolice.touched.ImportanciaSegurada && validApolice.errors.ImportanciaSegurada ? (
                                                <FormFeedback type="invalid">{validApolice.errors.ImportanciaSegurada}</FormFeedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Label className="form-label">Prêmio</Label>
                                            <NumericFormat prefix="R$" thousandSeparator="." decimalSeparator="," decimalScale={2} fixedDecimalScale={true} 
                                                className="form-control"
                                                name="Premio"
                                                placeholder="Valor do Prêmio"                                                        
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validApolice.handleChange}
                                                onBlur={validApolice.handleBlur}
                                                value={validApolice.values.Premio || ""}                                                
                                            />
                                            {validApolice.touched.Premio && validApolice.errors.Premio ? (
                                                <FormFeedback type="invalid">{validApolice.errors.Premio}</FormFeedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Label className="form-label">Endosso</Label>
                                            <Input
                                                name="Endosso"
                                                placeholder="Endosso"                                                        
                                                type="number"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validApolice.handleChange}
                                                onBlur={validApolice.handleBlur}
                                                value={validApolice.values.Endosso || ""}                                                        
                                            />                                                    
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Label className="form-label">Taxa</Label>
                                            <NumericFormat thousandSeparator="." decimalSeparator="," decimalScale={2} fixedDecimalScale={true} 
                                                className="form-control"
                                                name="Taxa"
                                                placeholder="Taxa da Apólice"                                                        
                                                maxLength={5}                                                        
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validApolice.handleChange}
                                                onBlur={validApolice.handleBlur}
                                                value={validApolice.values.Taxa || ""}                                                
                                            />
                                            {validApolice.touched.Taxa && validApolice.errors.Taxa ? (
                                                <FormFeedback type="invalid">{validApolice.errors.Taxa}</FormFeedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Label className="form-label">Início Vigência</Label>
                                            <Input
                                                name="InicioVigencia"
                                                placeholder="dd/mm/aaaa"
                                                type="text"
                                                // className="form-control"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validApolice.handleChange}
                                                onBlur={validApolice.handleBlur}
                                                value={validApolice.values.InicioVigencia || ""}
                                                invalid={
                                                    validApolice.touched.InicioVigencia && validApolice.errors.InicioVigencia ? true : false
                                                }
                                            />                                        
                                            {validApolice.touched.InicioVigencia && validApolice.errors.InicioVigencia ? (
                                                <FormFeedback type="invalid">{validApolice.errors.InicioVigencia}</FormFeedback>
                                            ) : null}
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Label className="form-label">Fim Vigência</Label>
                                            <Input
                                                name="FimVigencia"
                                                placeholder="dd/mm/aaaa"
                                                type="text"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validApolice.handleChange}
                                                onBlur={validApolice.handleBlur}
                                                value={validApolice.values.FimVigencia || ""}
                                                invalid={
                                                    validApolice.touched.FimVigencia && validApolice.errors.FimVigencia ? true : false
                                                }
                                            />
                                            {validApolice.touched.FimVigencia && validApolice.errors.FimVigencia ? (
                                                <FormFeedback type="invalid">{validApolice.errors.FimVigencia}</FormFeedback>
                                            ) : null}
                                        </div>
                                    </Col>                                                              
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="text-end">
                                    <button type="submit" className="btn btn-success save-apolice">Adicionar</button>
                                </div>
                            </Col>
                        </Row>                            
                    </ModalBody>
                </div>
            </Form>
        </Modal>
    )
}

ApoliceModal.propTypes = {
  onCloseClick: PropTypes.func,
  onAddApolice: PropTypes.func,
  show: PropTypes.any,
  processo: PropTypes.any,
  newIndex: PropTypes.any
}

export default ApoliceModal
